export default __webpack_public_path__ + "static/dashkit-layered-9cce5a241c2041c55647cacc9b6001fa.png";